import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {
    getSeedlingBeanNum,
    getSeedlingBeanList,
    getSeedlingBeanRecharge,
    WechatSeedlingBeanRecharge,
    getWechatAppUrl,
} from '@/api/miscellaneous';
import {Toast} from 'vant';
import config from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'RechargeSeedlingBean',
  setup(__props, { expose }) {
  expose();

const imageUrl = config.staticimgHost + 'wechat/h5/h50.png';
const linkUrl = `${config.webHost}/OpenMembership?viprank=3`;
const amount = ref(0);
const list = ref<any[]>([]);
const radio = ref(0);
const payData = ref({
    startOrder: 'startBuyBean', //创建订单
    startParams: {points: 0, price: 0}, //创建订单的参数
    aliCreate: 'createAliPayBean', //创建支付宝订单
    weCreate: 'createWeChatPayBean', //创建微信订单
    orderStatus: 'getOrderStatusBean',
});

const junmp = (url: string) => {
    window.location.href = url;
};

const getAmount = async () => {
    getSeedlingBeanNum().then(res => {
        amount.value = res as number;
    });
};
getAmount();

const getRechargeList = () => {
    getSeedlingBeanList().then((res: any) => {
        list.value = res;
        const {points, price} = res[0];
        radio.value = price;
        payData.value.startParams = {points, price};
    });
};
getRechargeList();

const rechargeChange = (item: any) => {
    const {points, price} = item;
    payData.value.startParams = {points, price};
};

const getPayData = () => {
    getSeedlingBeanRecharge(payData.value.startParams).then((res: any) => {
        const {id} = res;
        WechatSeedlingBeanRecharge({id}).then((res: any) => {
            let resData = JSON.parse(res);
            const {appid: appId, noncestr: nonceStr, sign: paySign, signType, timestamp: timeStamp} = resData;
            const data = {
                appId, //公众号名称，由商户传入
                timeStamp: String(timeStamp), //时间戳，自1970年以来的秒数
                nonceStr, //随机串
                package: resData.package, //扩展包
                signType, //微信签名方式：
                paySign, //微信签名
            };
            WeixinJSBridge.invoke('getBrandWCPayRequest', data, function (res) {
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    Toast.success('支付成功');
                    getAmount();
                } else {
                    Toast.fail(res.errMsg || '支付失败,请联系管理员');
                }
            });
        });
    });
};

const junmpToWechatApp = (type: number) => {
    getWechatAppUrl({
        url: 'packageA/pages/before_vip/index',
        query: `tab=0&level=${type}`,
    }).then(res => {
        location.href = JSON.parse(res).openlink;
    });
};

const __returned__ = { imageUrl, linkUrl, amount, list, radio, payData, junmp, getAmount, getRechargeList, rechargeChange, getPayData, junmpToWechatApp, ref, getSeedlingBeanNum, getSeedlingBeanList, getSeedlingBeanRecharge, WechatSeedlingBeanRecharge, getWechatAppUrl, Toast, config }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})